import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import {
    CANDIDATE_CATEGORY_FIELDS,
    LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY, ResponseCode
} from "@app/constants/Common";
import ReactChipInput from "react-chip-input";
import { arrayIncludeItem } from "@app/utils/CommonUtils";
import { requestCandidates } from "@app/services/CandidateService";
import CandidateListTable, { CandidateListMode } from "@pages/candidate/list/CandidateListTable";
import { requestStartRunJob } from "@app/services/JobService";
import { requestStartRunDVTJCUV } from "@pages/dvtjcuv/service/DVTJCUVService";
import { toast } from "react-toastify";
import fe from "react-datepicker";
import DVTJCUVNextFollowUpPlan from "@pages/candidate/list/DVTJCUVNextFollowUpPlan";
import { showMessage } from "@app/constants/Messages";
import SelectDVTJCUVMailTemplateContent from "@pages/dvtjcuv/rundvtjcuv/SelectDVTJCUVMailTemplateContent";
import {
    requestAddCddToFollowUpTabDVTJCUV,
    requestCheckFollowUpDVTJCUV
} from "@pages/dvtjcuv/service/DVTJCUVFollowUpService";
import { MailTempType } from "@pages/email/common/Constant";
import { InviteSendJobTodoWRec } from "@pages/dvtjcuv/common/Constant";
import { DVTJCUVWorkWithRecSendEmailInviteJobTabs } from "@pages/dvtjcuv/common/WorkWithRecTabs";

export const EmailInviteMode = {
    INVITE_EMAIL: 1,
    INVITE_EMAIL_FU: 2,
    INVITE_BRIEF_EMAIL: 3,
    INVITE_EMAIL_DN_UPDATE_INFO: 4,
    INVITE_EMAIL_FU_REC: 5,
    // Thêm 2 mode cho map Gửi email mời gửi job.
    INVITE_EMAIL_INVITE_SEND_JOB: 6,
    INVITE_EMAIL_INVITE_SEND_JOB_FU: 7,
}

const InitSearchConditions = {
    'candidate_ids': '',
    'categories': {},
}

const DVTJCUVEmailInviteModal = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentStep, setCurrentStep] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectMailTemplateId, setSelectMailTemplateId] = useState(null);

    const [nextFollowUpPlan, setNextFollowUpPlan] = useState({
        current_fu_campaign: "",
        next_fu_campaign: "",
        current_fu_strategy_date_time: "",
        next_fu_strategy_date_time: "",
        todo_w_cdd_dvtjcuv: "To ME follow up",
        invite_send_job_todo_w_rec: InviteSendJobTodoWRec.TO_ME_FOLLOW_UP,
        rec_current_fu_strategy_date_time: "",
        rec_current_fu_campaign: "",
    });

    const { mode, candidateIds, pipelines, isShow, onSearch, onClose } = props

    const fetchCandidateList = async () => {
        const params = {
            // page: page > 0 ? page : DEFAULT_PAGE,
            // size: DEFAULT_PAGE_SIZE,
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: searchConditions
        }

        const res = await requestCandidates(params);

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        searchConditions.candidate_ids = candidateIds
        if (pipelines && pipelines.length > 0) {
            if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
                nextFollowUpPlan.current_fu_strategy_date_time = pipelines[0].rec_next_fu_strategy_date_time
                nextFollowUpPlan.current_fu_campaign = pipelines[0].rec_next_fu_campaign
            } else {
                nextFollowUpPlan.current_fu_strategy_date_time = pipelines[0].next_fu_strategy_date_time
                nextFollowUpPlan.current_fu_campaign = pipelines[0].next_fu_campaign
            }
            //nextFollowUpPlan.invite_send_job_todo_w_rec = pipelines[0].invite_send_job_todo_w_rec
            setNextFollowUpPlan({ ...nextFollowUpPlan })
        }
        if (!isLoading) {
            fetchCandidateList()
        }
    }, [candidateIds, pipelines])

    const onChangeNextFollowUpPlan = (data) => {
        setNextFollowUpPlan(data)
        // localStorage.setItem(LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN, JSON.stringify(nextFollowUpPlan));
    }

    const onChangeMailTemp = (temp) => {
        setSelectMailTemplateId(temp ? temp.value : null)
    }

    const onAddCategoryItem = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchConditions.categories[fieldName] = arr
            setSearchConditions({ ...searchConditions })
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveCategoryItem = (index, fieldName) => {
        let arr = cloneDeep(searchConditions.categories[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchConditions.categories[fieldName] = arr
            setSearchConditions({ ...searchConditions })
        }
    }

    const onStartRunDVTJCUV = async () => {
        const requestBody = {
            candidate_ids: allCandidateIds,
            next_follow_up_plan: nextFollowUpPlan,
            mail_template_id: selectMailTemplateId,
            temp_pipeline: (pipelines && pipelines.length > 0) ? pipelines[0] : null,
            invite_mode: mode
        }
        // let funcRequest = requestStartRunDVTJCUV
        // if (mode === EmailInviteMode.INVITE_EMAIL_FU) {
        //     funcRequest = requestAddCddToFollowUpTabDVTJCUV
        // }

        const res = await requestStartRunDVTJCUV(requestBody)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const inviteResult = res.content.email_tab
            const notPermissionCandidateIds = inviteResult.not_permission_email_candidate_ids
            const needCheckingCandidateIds = inviteResult.need_checking_candidate_ids
            const needInputInfoCandidateIds = inviteResult.need_input_info_candidate_ids
            const approveDraftCandidateIds = inviteResult.approve_draft_candidate_ids
            let tabNo = 2;
            let forwardUrl = "/dvtjcuv/acquire-cdd#dvtjcuv-acquire-cdd-email-tab";
            if (mode === EmailInviteMode.INVITE_EMAIL_FU) {
                forwardUrl = "/dvtjcuv/acquire-cdd#dvtjcuv-acquire-cdd-fu-email-tab";
                tabNo = 3;
            } else if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB) {
                forwardUrl = "/dvtjcuv/work-with-recs#dvtjcuv-work-with-rec-send-email-invite-job-tab";
                tabNo = "1.1";
            } else if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
                forwardUrl = `/dvtjcuv/work-with-recs#${DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id}`;
                tabNo = "1.3";
            }
            showMessage(
                `Kết quả check:
                     Số UV tab 1: ${approveDraftCandidateIds.length}
                     Số UV tab 2: ${notPermissionCandidateIds.length}
                     Số UV tab 3: ${needCheckingCandidateIds.length}
                     Số UV tab 4: ${needInputInfoCandidateIds.length}`
            )
            window.location.href = forwardUrl;

            // Fix bug EE 13- không di chuyển màn hình sau khi check từ tab 1.2-cần FU
            if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
                window.location.reload();
            }
        } else {
            toast.error(res.message);
            alert(res.message)
        }
    }

    const onCheck = async () => {
        if (currentStep === 1) {
            setCurrentStep(2)
            await fetchCandidateList()
        } else if (currentStep === 2) {
            onStartRunDVTJCUV()
        }
    }

    const createScreenTitle = () => {
        if (mode === EmailInviteMode.INVITE_EMAIL_FU) {
            return "Email FU DVTJCUV"
        }

        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB) {
            return "Email mời gửi Job"
        }
        if (mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) {
            return "Email mời gửi Job (FU)"
        }

        return "Email mời DVTJCUV"
    }

    return (
        <>
            <Modal show={isShow}
                size={'xl'}
                onHide={onClose}
                animation={false}>
                <Modal.Header>
                    <Modal.Title>{createScreenTitle()}</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{ overflowY: 'auto', maxHeight: '70vh' }}>
                    {currentStep === 1 &&
                        <div className='card card-default'>
                            <div className='card-header'>
                                <h3 className='card-title text-bold'>Industry & Function</h3>
                                {/*<div className='card-tools'>*/}
                                {/*    <button type='button'*/}
                                {/*            className='btn btn-primary btn-sm'*/}
                                {/*            onClick={() => {*/}
                                {/*                fetchCandidateList()*/}
                                {/*            }}*/}
                                {/*    >*/}
                                {/*        <i className='fas fa-search mr-2'/>*/}
                                {/*        Search*/}
                                {/*    </button>*/}
                                {/*</div>*/}
                            </div>
                            <div className='card-body row'>
                                {CANDIDATE_CATEGORY_FIELDS.map((field, i) => {
                                    let fieldValue = searchConditions.categories[field.key] ? searchConditions.categories[field.key] : []
                                    if (field.key === 'industry_function') {
                                        return ""
                                    }
                                    return <div className='input-group col-sm-6 mt-3'>
                                        <label className={'w-100'}>{field.label}</label>
                                        <ReactChipInput
                                            classes="class1 class2 w-100"
                                            chips={fieldValue}
                                            onSubmit={value => onAddCategoryItem(value, field.key)}
                                            onRemove={index => onRemoveCategoryItem(index, field.key)}
                                        />
                                    </div>
                                })}
                            </div>
                        </div>
                    }
                    {currentStep === 2 &&
                        <>
                            <SelectDVTJCUVMailTemplateContent
                                tempType={
                                    mode === EmailInviteMode.INVITE_EMAIL_FU ?
                                        MailTempType.DVTJCUV_EMAIL_FU : MailTempType.DVTJCUV_INVITE_EMAIL}
                                onSelect={temp => onChangeMailTemp(temp)} />
                            <DVTJCUVNextFollowUpPlan
                                mode={mode}
                                onChange={(data) => onChangeNextFollowUpPlan(data)}
                                nextFollowUpPlan={nextFollowUpPlan}
                            />
                            <div className={'card card-default'}>
                                <div className='card-header'>
                                    <h3 className='card-title text-bold'>Danh sách Persons</h3>
                                </div>
                                <div className='card-body'>
                                    <CandidateListTable candidates={candidates}
                                        allCandidateIds={allCandidateIds}
                                        mode={CandidateListMode.CANDIDATE_LIST}
                                        totalCount={totalCount}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type='button'
                        className='btn btn-primary'
                        disabled={candidates.length === 0}
                        onClick={() => onCheck()}>
                        Check
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DVTJCUVEmailInviteModal;
